export default {
  dialogContainer: {
    maxWidth: 400,
    padding: '30px 50px 56px 50px',
  },
};
